// extracted by mini-css-extract-plugin
module.exports = {"link":"jargon-summary-module--link--1mjdf","inner":"jargon-summary-module--inner--3GyiH"};